export default {
  label: 'Epost',
  error: 'Ange din epost'
}
